/** A step as far as this check is concerned: only its slot mode matters. */
interface StepWithSlotMode {
  slotMode?: string | null;
}

/**
 * True when the journey has a step in PAIRED slot mode — the Story of Us "your stones, your
 * moments" step, which no other product uses.
 *
 * Story-of-Us-only presentation (the three-column base step, the Figma footer) is gated on this
 * rather than on a product handle, so it follows the configuration wherever it is used.
 *
 * @param steps - The journey's steps: the steps Map (as personalisationData and the context
 *   hold them) or any iterable of steps. Empty placeholders and null entries are ignored.
 * @returns Whether any step's slotMode is PAIRED.
 */
export function isPairedJourney(
  steps:
    | Map<unknown, StepWithSlotMode | null | undefined>
    | Iterable<StepWithSlotMode | null | undefined>
    | null
    | undefined
): boolean {
  if (!steps) return false;

  const values = steps instanceof Map ? steps.values() : steps;
  for (const step of values) {
    if (step?.slotMode === 'PAIRED') return true;
  }
  return false;
}
